import { SET_ENTITY } from "@/store/mutation-types";

const module = "Options";

export default {
  namespaced: true,
  state: {
    usersList: [],
    options: {
      html_docs_path:"",
      pdf_docs_path:"",
      xml_docs_path:"",
      main_port:NaN,
      db: {
        type: "MSSQL",
        server: "",
        port:NaN,
        password: "",
        user: "",
        name_db: "",
        sspi: false      
      }
    },
    declList: [],
  },

  actions: {
    async addUser(data) {
      await this.$api.users.addUser(data);
    },
    async delUser(data) {
      await this.$api.users.delUsers(data);
    },
    async getUsers({ commit }) {
      const data = await this.$api.users.getUsers();
      commit(
        SET_ENTITY,
        {
          module: module,
          entity: "usersList",
          value: data
        },
        { root: true }
      );
    },

    async updUsers({commit}, data) {
      await this.$api.users.updUsersList(data);
      commit(
        SET_ENTITY,
        {
          module: module,
          entity: "usersList",
          value: data
        },
        { root: true }
      );
    },

    async getListDecl({state, commit}, params = {}) {
      if (state.declList.length != 0) return; 
      const items = await this.$api.dcl.getListDecl(params);
      commit(
        SET_ENTITY,
        {
          module: module,
          entity: "declList",
          value: items
        },
        { root: true }
      );
    },

    async getOptions({ commit }) {
      const data = await this.$api.optgeneral.getOptions();
      commit(
        SET_ENTITY,
        {
          module: module,
          entity: "options",
          value: data
        },
        { root: true }
      );


    },

    async updOptions({ commit },data) {
      commit(
        SET_ENTITY,
        {
          module: module,
          entity: "options",
          value: data
        },
        { root: true }
      );
      await this.$api.optgeneral.updOptions(data);

    },
    
  },
};